export { buildSdinFoundationModule } from './build'

export type { SdinFoundationModuleBuildingOptions } from './build'
